import { FC } from 'react'
import useHover from 'hooks/useHover'
import { ImagePlus } from 'lucide-react'
import { useSelector } from 'react-redux'
import { InputFile, UploadFileProps } from '@wellesley/ui'
import { platformSettingsSlice } from '@wellesley/settings'
import { getAcceptList } from '@wellesley/uploads'

type TAddMediaButton = {
  canUpload?: boolean
  isDisabled?: boolean
  onAddMedia(props: UploadFileProps[]): void
}

const AddMediaButton: FC<TAddMediaButton> = ({
  canUpload,
  isDisabled,
  onAddMedia,
}) => {
  const [ref, isHovered] = useHover<HTMLDivElement>()
  const allExtensions = useSelector(
    platformSettingsSlice.selectors.selectFullExtensionsList,
  )

  const acceptList = getAcceptList(allExtensions)

  const handleClickLabel = () => {
    ref.current?.querySelector('input')?.click()
  }

  const notActive = !canUpload || isDisabled

  const iconColor = notActive
    ? 'var(--gray-300)'
    : isHovered
      ? 'var(--blue-500)'
      : 'var(--gray-500)'

  return (
    <div ref={ref} onClick={handleClickLabel}>
      <ImagePlus
        size={24}
        color={iconColor}
        className={notActive ? 'cursor-not-allowed' : 'cursor-pointer'}
        strokeWidth="2px"
      />
      <InputFile
        accept={acceptList}
        disabled={isDisabled}
        handleUpload={onAddMedia}
        multiple
      />
    </div>
  )
}

export default AddMediaButton
